import React from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useState } from "react";
import { useEffect } from "react";
import { getUserProfilePhoto, viewUserProfile } from "../../Redux/User/action";
import { useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ringer from "../../assets/sounds/facebookchat.mp3";
import { firebaseConfig } from "../../fireBaseConfig";
import {
  convertSecondsToTime,
  download_url,
  getFileTypeFromUrl,
  isValidUrl,
} from "../functions";
import { getStorage } from "firebase/storage";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import styled from "styled-components/macro";
import SmallLoder from "../Loaders/SmallLoder";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  getWalletDetails,
  offlineNotification,
} from "../../Redux/Wallet/action";
import ToasterMessage from "../ToasterMessage";
import { readAllNotification } from "../../Redux/Chats/action";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import ZIM from "zego-zim-web";
import { callDuration, preventLoginPushNotification, updateCallDuration } from "../../Redux/Call/action";
import Timer from "../ChatCall/Timer";
import OneSignalReact from "react-onesignal";
import CallrateModal from "../CallrateModal";
import OneSignal from "react-onesignal";

const Chat = () => {

  // Call Function Start
  const [seconds, setSeconds] = useState(0);
  const [isWaitingCall, setIsWaitingCall] = useState(false);
  const [joinRoom, setJoinRoom] = useState(false);
  const [onLeaveRoom, setOnLeaveRoom] = useState(false);

  const [totalTime, setTotalTime] = useState(null);
  const [checkTime, setCheckTime] = useState(null);


  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const roomID = "room01";
  // const userID = localStorage.getItem("user_id");
  const userID = localStorage.getItem("user_name");
  const userName = userID;

  // ======================================================================
  const [zp, setZp] = useState(null);
  const cancelButton = useRef(null);
  const mounted = async (el: HTMLDivElement) => {
    if (!el || zp) return;
    // generate token
    // const { token } = await generateToken(
    //   'https://nextjs-token-callinvitation.vercel.app/api',
    //   userID
    // );

    const appID = 1485872462;
    const serverSecret = "8e9ec2e8a91d24fd83fc68a74bda9f04";
    const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomID,
      userID,
      userName
    );
    const myZp = ZegoUIKitPrebuilt.create(TOKEN);
    myZp.addPlugins({ ZIM });
    myZp.setCallInvitationConfig({
      enableCustomCallInvitationWaitingPage: true,
      onWaitingPageWhenSending: (callType, callees, cancel) => {
        setIsWaitingCall(true)
        console.warn(cancelButton);
        cancelButton.current.onclick = () => {
          cancel();
          setIsWaitingCall(false);
        };
      },

      onCallInvitationEnded: (reason) => {
        // You will need to hide your custom waiting page when your call invitation is not connected successfully.
        //  waitingPageDom.style.display = 'none';
        setIsWaitingCall(false);
      },
      onSetRoomConfigBeforeJoining: () => ({
        showUserList: true,
        // lowerLeftNotification:{
        //   showUserJoinAndLeave:false,
        //   showTextChat:false,
        // },
        // showLayoutButton:false,
        // showPinButton:false,

        turnOnCameraWhenJoining: false,
        showMyCameraToggleButton: false,
        showAudioVideoSettingsButton: false,
        showScreenSharingButton: false,
        showTextChat: false,
        showOnlyAudioUser: true,
        showNonVideoUser: true,
        useFrontFacingCamera: false,
        autoLeaveRoomWhenOnlySelfInRoom: true,
        branding: {
          logoURL:
            "data:image/png;base64,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",
        },
        onUserAvatarSetter: (userList) => {
          userList.forEach((user) => {
            getUserProfilePhoto(user.userID)((response) => {
              const imageUrl = `https://api.taskde.com${response?.data?.data?.image}`;
              user.setUserAvatar(imageUrl);
              return response?.data?.data?.image
            })


            // if (user.userID === "uvaist") {

            //   user.setUserAvatar(
            //     "http://taskde.aventusinformatics.com/media/users/51_ownRWni.png"
            //   );
            // } else if (user.userID === 'roufan') {
            //   user.setUserAvatar(
            //     "http://taskde.aventusinformatics.com/media/users/52_hF5HLR7.png"
            //   );

            // }

          });

        },
        onUserJoin: () => {
          setStartTime(new Date());
          setJoinRoom(true);
          setIsWaitingCall(false)

        },
        onLeaveRoom: () => {

          setJoinRoom(false);
          setOnLeaveRoom(true);
        },
      }),

      onOutgoingCallAccepted: () => {
        setIsWaitingCall(false)
      },
      // onCallInvitationEnded: () => {

      //     setJoinRoom(false)
      //     setEndTime(new Date())
      //     setSeconds(0)

      //     if (totalTime != 'unlimited') {
      //         callEndFun()
      //     }
      // }

    });
    setZp(myZp);
  };
  // =========================================================================
  useEffect(() => {
    if (!joinRoom && onLeaveRoom) {
      setEndTime(new Date());
      setSeconds(0);
      if (totalTime != "unlimited") {
        callEndFun();
      }
    }
  }, [joinRoom, onLeaveRoom]);

  const callEndFun = async (is_reload = false) => {
    // const lasttime = startTime + 1000
    let callDuration = (new Date() - startTime) / 1000;


    await updateCallDuration(
      localStorage.getItem("user_id"),
      state?.task_detail,
      callDuration
    )((response) => {
      if (response.status) {
        setShowCallRateModal(true)
        localStorage.setItem('call_rate', response?.data?.total_cost)
        localStorage.setItem('call_time', response?.data?.total_time)
        is_reload && window.location.reload(false);
      }
    });
  };
  useEffect(() => {
    if (localStorage.getItem("user_type") === "1") {
      callDuration(
        localStorage.getItem("user_id"),
        state.task_detail
      )((response) => {
        if (response.status) {
          if (response.data.data !== "unlimited") {

            setTotalTime(response.data.data * 60000);
            setCheckTime(response.data.data * 60);
            // setOgTotalTime(response.data.data - 2)
          } else {
            setTotalTime(response.data.data);
            setCheckTime(response.data.data);

            // setOgTotalTime(response.data.data)
          }
        } else {
        }
      });
    }
  }, []);
  useEffect(() => {
    if (
      joinRoom &&
      totalTime != "unlimited" &&
      localStorage.getItem("user_type") == "1"
    ) {
      const timer = setTimeout(() => {
        callEndFun(true);
      }, totalTime);
      return () => clearTimeout(timer);
    }
  }, [joinRoom]);
  useEffect(() => {
    if (joinRoom) {
      const intervalId = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [joinRoom]);

  function callInvitation(userid) {
    zp.sendCallInvitation({
      callees: [{ userID: userid }],
      callType: 0,
      timeout: 60,
    })
      .then((res) => {
        console.warn(res);
      })
      .catch((err) => {
        console.warn(err);
      });
  }
  // Call Function END Here

  const [showCallRateModal, setShowCallRateModal] = useState(false);
  const [toaster, setToaster] = useState("");
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  const [walletBalance, setWaletBlanace] = useState(0);

  const [pageLoader, setPageLoader] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [showOption, setOption] = useState(false);
  const [percent, setPercent] = useState(0);
  const [messages, setMessages] = useState([]);
  // const { collection } = useParams();
  const [user, setUser] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const inputRef = useRef();
  const audio = new Audio(ringer);
  const bottomRef = useRef(null);
  const { state, pathname } = useLocation();
  const [isUserOnline, setIsUserOnline] = useState(
    localStorage.getItem("isUserOnline")
      ? true
      : state?.reciever?.status &&
        state?.reciever?.status[0] &&
        state?.reciever?.status[0].status &&
        state?.reciever?.status[0].status == 1
        ? true
        : false
  );
  const { collection } = state;
  console.log(collection,"collection");
  
  const BASE_URL = "https://api.taskde.com";
  audio.loop = false;
  // const { uid, displayName, photoURL } = user;

  const app = firebase.initializeApp(firebaseConfig);
  const storage = getStorage(app);
  const db = firebase.firestore(app);
  const messagesRef = db.collection(collection);
  const query = db.collection(collection).orderBy("timestamp").limit(100);

  const fetchChatMessages = () => {
    setPageLoader(true);
    const unsubscribe = query.onSnapshot((querySnapshot) => {
      // Get all documents from collection - with IDs
      const data = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setMessages(data);
      // bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
      setPageLoader(false);
    });

    // Detach listener
    return unsubscribe;
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOption(false);
          // alert("You clicked outside of me!");
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(wrapperRef);

  useEffect(() => {
    viewUserProfile()((response) => {
      if (response && response.status) {
        setUser(response?.data?.data[0]);
      }
    });
  }, []);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: "end" });
  }, [messages, percent]);

  useEffect(() => {
    // Subscribe to query with onSnapshot
    fetchChatMessages();
  }, []);
  const handleOnChange = (e) => {
    setNewMessage(e.target.value);
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();

    const trimmedMessage = newMessage.trim();
    if (trimmedMessage) {
      // Add new message in Firestore
      sendMessage("text", trimmedMessage);
      // Clear input field
      setNewMessage("");
      audio.play();
    }
  };
  const sendMessage = (type, text) => {
    let data = {
      text: text,
      type: type,
      timestamp: text,
      sender: user?.user?.email,
      reciever_email: state.reciever.email,
      assigned_task: state.task_detail_id,
    };
    offlineNotification(data)((response) => {
      if (response && response.status) {
      }
    });
    messagesRef.add({
      text: text,
      type: type,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      sender: user?.user?.id,
      sender_email: user?.user?.email,
    });
  };

  function handleUpload(e, name) {
    const file = e.target.files[0];
    if (!file) {
      alert("Please choose a file first!");
    } else {
      if (file.size > 2000000 && name === "video") {
        alert("Please upload file less than 2MB. Thanks!!");
      } else {
        const storageRef = ref(storage, `/${name}/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const percent = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            // update progress
            setPercent(percent);
          },

          () => {
            // download url
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
              sendMessage(name, url);
              setPercent(0);
            });
          }
        );
      }
    }
  }
  const handleDelete = (messageId) => {
    firebase.firestore().collection(collection).doc(messageId).delete();
    setCurrentId(null);
    setOption(false);
  };

  useEffect(() => {
    if (!showOption) {
      setCurrentId(null);
    }
  }, [showOption]);

  // useEffect(() => {
  //   let is_call = localStorage.getItem("is_call");
  //   if (is_call == "true") {
  //     localStorage.setItem("is_call", false);
  //     window.location.reload();
  //   }
  // }, []);
  const handleToCall = async () => {
    // await getWalletDetails()((response) => {
    //   if (response && response.status) {
    //     setWaletBlanace(response.data.data.wallet_balance);
    //   }
    // });

    if (checkTime === "unlimited" || checkTime >= 1) {
      callInvitation(state?.reciever?.username);
    } else {
      setToaster("Low Balance");
      setTimeout(() => {
        setToaster("");
      }, 2000);
    }
  };


  const callApi = async () => {
    await readAllNotification(
      state.task_detail_id,
      false,
      localStorage.getItem("onesignal_token")
    )((response) => {
    });
  };
  useEffect(() => {
    return () => {
      window.onpopstate = () => {
        callApi();
      };
    };
  }, []);
  // useEffect(() => {
  //   const handleTabClose = (event) => {
  //     event.preventDefault();

  //   
  //     if (
  //       // joinRoom &&
  //       totalTime != "unlimited" &&
  //       localStorage.getItem("user_type") == "1"
  //     ) {
  //         callEndFun();
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleTabClose);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleTabClose);
  //   };
  // }, []);
  useEffect(() => {
    OneSignalReact.on("notificationDisplay", function (event) {
      // event.close();
      const notification_data = event?.data?.status;
      if (notification_data === "user status") {
        if (event?.data?.user_state === "offline") {

          setIsUserOnline(false);
          localStorage.setItem("isUserOnline", false);
        } else if (event?.data?.user_state === "online") {

          setIsUserOnline(true);
          localStorage.setItem("isUserOnline", true);
        }
      }
    });

    // FOR RECIVING THE PUSH NOTIFICATION IN CHAT PAGE
    preventLoginPushNotification(true, localStorage.getItem('onesignal_token'), true)((response) => {
    })
    // ========= SET ONE SIGNAL START =========
    OneSignal.init({
      autoRegister: false,
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: process.env.REACT_APP_ONESIGNAL_ALLOW_LOCALHOST,
      // promptOptions: false,
    })
    // ========= SET ONE SIGNAL END =========
  }, []);

  const submitref = useRef()
  const onKeySubmit = (event) => {
    if (event.keyCode == 13 && !event.shiftKey) {
      submitref.current.click()
    }
  }

  return (
    <React.Fragment>
      {joinRoom && (
        <div className="call-timer">
          <Timer time={seconds} />
        </div>
      )}
      <ToasterMessage toaster={toaster} setToaster={setToaster} />
      <section ref={mounted} class="msger">

        {/* CALL INVITIATION PAGE START HEARE */}
        <div
          style={{ display: isWaitingCall ? 'block' : 'none' }}
          class="waiting_page">
          <p class="waitingpage_calling">Calling…</p>
          <div class="waitingpage_profile">
            <div
              class="waitingpage_pic"
              style={{ color: "rgb(85, 123, 255)" }}
            >
              <img
                src={
                  state?.reciever?.image &&
                    state?.reciever?.image[0] &&
                    state?.reciever?.image[0].image
                    ? BASE_URL + state?.reciever?.image[0].image
                    : "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg"
                }
                className="img-fluid"
                alt=""
              />

            </div>
            <p class="waitingpage_content"></p>
          </div>
          {/* <button ref={cancelButton} class="waitingpage_end">
            End call
          </button> */}
          <button
            class="waitingpage_end"
            // style={{ display: showCancel ? 'block' : 'none' }}
            ref={cancelButton}
          >
            End call
          </button>
        </div>
        {/* CALL INVITIATION PAGE END HEARE */}


        <div className="container">
          <div className="row  h-100">
            <div className="col-lg-12 msger-boxshadow p-0">
              <header class="msger-header">
                <div class="msger-header-title">
                  <div
                    className="btn-outline-secondary d-flex border-0"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={
                        state?.reciever?.image &&
                          state?.reciever?.image[0] &&
                          state?.reciever?.image[0].image
                          ? BASE_URL + state?.reciever?.image[0].image
                          : "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg"
                      }
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div>
                    <h5>{state?.reciever?.username}</h5>
                    <span className="status">
                      {isUserOnline ? "Online" : "Offline"}
                    </span>
                  </div>
                </div>
                {/* <div onClick={() => { callInvitation(state?.reciever?.username) }} class="me-3 msger-header-options"></div> */}
                <div className="d-flex align-items-center">
                  {
                    // isUserOnline &&
                    localStorage?.getItem("user_type") == 1 && (
                      <div
                        onClick={() => {
                          isUserOnline
                            ? handleToCall()
                            : setToaster("User Offline");
                          setTimeout(() => {
                            setToaster("");
                          }, 2000);
                          // alert("User is offline");
                        }}
                        class="me-5 msger-header-options"
                      >
                        <span>
                          <i class="bi bi-telephone-fill"></i>
                        </span>
                      </div>
                    )
                  }
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    class="me-3 msger-header-options"
                  >
                    <span>
                      <i class="bi bi-x" style={{ fontSize: "26px" }}></i>
                    </span>
                  </div>
                </div>
              </header>

              <main class="msger-chat">
                {pageLoader ? (
                  <SmallLoder />
                ) : (
                  messages?.map((message) =>
                    message?.sender_email == user?.user?.email ? (
                      <div class="msg right-msg" key={message.id}>
                        <div
                          style={{ position: "relative" }}
                          class="msg-bubble"
                        >
                          <OptionListContainer
                            showOption={
                              showOption && currentId == message.id
                                ? true
                                : false
                            }
                          >
                            <OptionList
                              onClick={(id) => handleDelete(message.id)}
                            >
                              Delete
                            </OptionList>
                          </OptionListContainer>

                          <div class="msg-text">
                            <div
                              onClick={() => {
                                setOption(!showOption);
                                setCurrentId(message.id);
                              }}
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                marginBottom: "10px",
                                cursor: "pointer",
                              }}
                              className="option-dots"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-three-dots-vertical"
                                viewBox="0 0 16 16"
                              >
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                              </svg>
                            </div>
                            {message.type == "image" ? (
                              <div style={{ width: "100%" }}>
                                <img
                                  style={{
                                    display: "block",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  src={message.text}
                                />
                              </div>
                            ) : message.type == "file" ? (
                              <div>
                                {getFileTypeFromUrl(message.text, "type") ==
                                  "pdf" ? (
                                  // <embed src=
                                  //     {message.text}
                                  //     // width="800"
                                  //     height="100"
                                  // />
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="file-container"
                                  >
                                    <i
                                      style={{
                                        fontSize: "50px",
                                        color: "red",
                                      }}
                                      class="bi bi-file-pdf-fill"
                                    ></i>

                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "200px",
                                      }}
                                      className="ms-1"
                                    >
                                      {getFileTypeFromUrl(
                                        message.text,
                                        "name"
                                      )}
                                    </span>
                                  </div>
                                ) : getFileTypeFromUrl(
                                  message.text,
                                  "type"
                                ) == "docx" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="file-container"
                                  >
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA8CAMAAAD8KXLNAAAAulBMVEUAAACPw/ePw/lgqvVfqvaUx/mQxPhfqfWjz/lfqfVfqvZgp/9cp/ZfqvZgqvaayPpTpPVfqvVjpvNgqfaQw/mjzvq42PdfqvZgqvZiq/ZwsveRxflkqe9rsPdcqPZeqPRorvfN5fzw9/5bp/Z2tvdZoOqTxvqCuvPj8P7+//+QxPmBvfl3su+Pw/lWpfWx1fuJwPlUpPWVxvnp8/7////4+/9ure3C3/uq0fvb7P1usffn8v15tfFMmOceGILeAAAAF3RSTlMAIdHm7ijJ+JH8eQeTzaw68foX1Ll9kGZdllAAAAEQSURBVHgB7dZVcsMwFIVhhTkp5krmMJcZ9r+sMl7PEczopfC/f7ZFtoUQreZuWVepJ3g73VKtoSvaKzDS6kp9abSsMtQumQ1HtYbZcCSl2TBkZRiyNU+o4m6WxYqzeUIFd/P0eO7m6fGsDUNmQ+lsypA0ll6E4XdkYSbrTTj96AlJczSJ1rOP7vrQsFt9dl/HBnX8y00Cg0YFqBtkKJuDbgdEwMSLM9Cp9GnUCWoD54AOYH7XZwRDhtQRagVNfA5azKXX9RmirpGRaowKfM6bt/NDekPZYa6rIAEGz/VwNfJvskGuy3FimAOVzzhvlA+Z//f1vyltu5p90Sw5mq2eEG1H03759e+Ua7aVO82WeASxdDP0M8Z9fAAAAABJRU5ErkJggg==" />
                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "200px",
                                      }}
                                      className="ms-1"
                                    >
                                      {getFileTypeFromUrl(
                                        message.text,
                                        "name"
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  // <embed src=
                                  //     {message.text}
                                  //     // width="800"
                                  //     height="100"
                                  // />
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="file-container"
                                  >
                                    <i
                                      style={{ fontSize: "50px" }}
                                      class="bi bi-file-text"
                                    ></i>

                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "200px",
                                      }}
                                      className="ms-1"
                                    >
                                      {getFileTypeFromUrl(
                                        message.text,
                                        "name"
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            ) : message.type == "video" ? (
                              <div style={{ cursor: "pointer" }}>
                                <video
                                  height="240"
                                  style={{ width: "500px" }}
                                  controls
                                >
                                  <source
                                    src={message.text}
                                    type="video/mp4"
                                  />
                                </video>
                              </div>
                            ) : isValidUrl(message.text) ? (
                              <a href={message.text}>{message.text}</a>
                            ) : (
                              message.text
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            class="mt-2 text-end"
                          >
                            {message.type !== "text" && (
                              <span
                                style={{ color: "black", cursor: "pointer" }}
                                onClick={() => {
                                  download_url(message.text);
                                }}
                              >
                                <i class="bi bi-arrow-down-circle"></i>
                              </span>
                            )}

                            <div class="msg-info-time">
                              {message?.timestamp?.seconds &&
                                convertSecondsToTime(
                                  message?.timestamp?.seconds
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div class="msg left-msg" key={message.id}>
                        <div class="msg-bubble">
                          <div class="msg-text">
                            {message.type == "image" ? (
                              <div style={{ width: "100%" }}>
                                <img
                                  style={{
                                    display: "block",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  src={message.text}
                                />
                              </div>
                            ) : message.type == "file" ? (
                              <div>
                                {getFileTypeFromUrl(message.text, "type") ==
                                  "pdf" ? (
                                  // <embed src=
                                  //     {message.text}
                                  //     // width="800"
                                  //     height="100"
                                  // />
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="file-container"
                                  >
                                    <i
                                      style={{
                                        fontSize: "50px",
                                        color: "red",
                                      }}
                                      class="bi bi-file-pdf-fill"
                                    ></i>

                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "200px",
                                      }}
                                      className="ms-1"
                                    >
                                      {getFileTypeFromUrl(
                                        message.text,
                                        "name"
                                      )}
                                    </span>
                                  </div>
                                ) : getFileTypeFromUrl(
                                  message.text,
                                  "type"
                                ) == "docx" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="file-container"
                                  >
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA8CAMAAAD8KXLNAAAAulBMVEUAAACPw/ePw/lgqvVfqvaUx/mQxPhfqfWjz/lfqfVfqvZgp/9cp/ZfqvZgqvaayPpTpPVfqvVjpvNgqfaQw/mjzvq42PdfqvZgqvZiq/ZwsveRxflkqe9rsPdcqPZeqPRorvfN5fzw9/5bp/Z2tvdZoOqTxvqCuvPj8P7+//+QxPmBvfl3su+Pw/lWpfWx1fuJwPlUpPWVxvnp8/7////4+/9ure3C3/uq0fvb7P1usffn8v15tfFMmOceGILeAAAAF3RSTlMAIdHm7ijJ+JH8eQeTzaw68foX1Ll9kGZdllAAAAEQSURBVHgB7dZVcsMwFIVhhTkp5krmMJcZ9r+sMl7PEczopfC/f7ZFtoUQreZuWVepJ3g73VKtoSvaKzDS6kp9abSsMtQumQ1HtYbZcCSl2TBkZRiyNU+o4m6WxYqzeUIFd/P0eO7m6fGsDUNmQ+lsypA0ll6E4XdkYSbrTTj96AlJczSJ1rOP7vrQsFt9dl/HBnX8y00Cg0YFqBtkKJuDbgdEwMSLM9Cp9GnUCWoD54AOYH7XZwRDhtQRagVNfA5azKXX9RmirpGRaowKfM6bt/NDekPZYa6rIAEGz/VwNfJvskGuy3FimAOVzzhvlA+Z//f1vyltu5p90Sw5mq2eEG1H03759e+Ua7aVO82WeASxdDP0M8Z9fAAAAABJRU5ErkJggg==" />
                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "200px",
                                      }}
                                      className="ms-1"
                                    >
                                      {getFileTypeFromUrl(
                                        message.text,
                                        "name"
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  // <embed src=
                                  //     {message.text}
                                  //     // width="800"
                                  //     height="100"
                                  // />
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="file-container"
                                  >
                                    <i
                                      style={{ fontSize: "50px" }}
                                      class="bi bi-file-text"
                                    ></i>

                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "200px",
                                      }}
                                      className="ms-1"
                                    >
                                      {getFileTypeFromUrl(
                                        message.text,
                                        "name"
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            ) : message.type == "video" ? (
                              <div style={{ cursor: "pointer" }}>
                                <video
                                  height="240"
                                  style={{ width: "500px" }}
                                  controls
                                >
                                  <source
                                    src={message.text}
                                    type="video/mp4"
                                  />
                                </video>
                              </div>
                            ) : isValidUrl(message.text) ? (
                              <a href={message.text}>{message.text}</a>
                            ) : (
                              message.text
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            class="mt-2 text-end"
                          >
                            {message.type !== "text" && (
                              <span
                                style={{ color: "black", cursor: "pointer" }}
                                onClick={() => {
                                  download_url(message.text);
                                }}
                              >
                                <i class="bi bi-arrow-down-circle"></i>
                              </span>
                            )}

                            <div class="msg-info-time">
                              {message?.timestamp?.seconds &&
                                convertSecondsToTime(
                                  message?.timestamp?.seconds
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )
                )}
                {percent > 0 ? (
                  <CircularProgressContainer>
                    <CircularProgressbar
                      text={`${percent}%`}
                      value={percent}
                    />
                  </CircularProgressContainer>
                ) : null}
                <div ref={bottomRef}></div>
              </main>

              <form class="msger-inputarea" onSubmit={handleOnSubmit}>
                <textarea
                  ref={inputRef}
                  type="text"
                  value={newMessage}
                  onChange={handleOnChange}
                  class="msger-input"
                  placeholder="Enter your message..."
                  onKeyUp={(e) => onKeySubmit(e)}
                />
                <div class="dropdown dropup p-0">
                  <button
                    class=""
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-paperclip"></i>
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <span class="dropdown-item" href="#">
                        <div class="file">
                          <label for="input-file3" title="Images">
                            <i
                              class="bi bi-images"
                              style={{ color: "#fff" }}
                            ></i>

                          </label>
                          <input
                            onChange={(e) => {
                              handleUpload(e, "image");
                            }}
                            id="input-file3"
                            accept="image/*"
                            type="file"
                          />
                        </div>
                      </span>
                    </li>
                    <li>
                      <span class="dropdown-item" href="#">
                        <div class="file">
                          <label for="input-file2" title="Files">
                            <i
                              class="bi bi-files"
                              style={{ color: "#fff" }}
                            ></i>
                          </label>
                          <input
                            id="input-file2"
                            onChange={(e) => {
                              handleUpload(e, "file");
                            }}
                            type="file"
                            accept=".csv,.xls,.xlsx,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          />
                        </div>
                      </span>
                    </li>
                    <li>
                      <span class="dropdown-item" href="#">
                        <div class="file">
                          <label for="input-file1" title="Videos">
                            <i
                              class="bi bi-camera-video"
                              style={{ color: "#fff" }}
                            ></i>
                          </label>
                          <input
                            type="file"
                            onChange={(e) => {
                              handleUpload(e, "video");
                            }}
                            id="input-file1"
                            accept="video/*"
                          />
                        </div>
                      </span>
                    </li>
                  </ul>
                </div>
                <button
                  type="submit"
                  disabled={!newMessage}
                  class="msger-send-btn"
                  ref={submitref}
                >
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
        <CallrateModal setShowCallRateModal={setShowCallRateModal} showCallRateModal={showCallRateModal} />

      </section>

    </React.Fragment>
  );
};

export default Chat;
const CircularProgressContainer = styled.div`
  display: flex;
  justify-content: end;
  svg {
    width: 10%;
  }
`;
const OptionListContainer = styled.div`
  /* opacity: ${({ showOption }) => (showOption ? "1" : "0")}; */
  display: ${({ showOption }) => (showOption ? "block" : "none")};
  /* transform: ${({ showOption }) =>
    showOption ? "translateY(0)" : "translateY(-200%)"}; */

  /* visibility: ${({ showOption }) => (showOption ? "unset" : "hidden")}; */
  transition: all ease-in-out 0.3s;
  background: #fff;
  position: absolute;
  width: 100px;
  border-radius: 3px;
  top: 0;
  right: 25px;
  box-shadow: 0px 0px 3px 0px #ccc;
  z-index: 10;
`;
const OptionList = styled.div`
  display: block;
  padding: 3px;
  margin: 5px;
  background: #fff;
  transition: background ease-in-out 0.3s;

  &:hover {
    cursor: pointer;
    background: hsl(0deg 0% 92%);
    transition: background ease-in-out 0.3s;
  }
`;
